module.exports = __webpack_public_path__ + "static/media/Illus-Empty_2@3x.1e80e11b.png";